module.exports = __webpack_public_path__ + "static/media/eth-logo.88f96491.png";